import {Card, Row} from 'antd';

export const BuyerInvoiceProfile = ({buyer, props}) => {

    if ((buyer === null) || (buyer === undefined)) {
        return;
    }

    const {addressId, streetAddress, streetAddressLine2, city, state, postalCode, country} = buyer;
    const addressBlock = addressId ?
        <>
        <p/>
        <Row>{streetAddress}</Row>
        {((streetAddressLine2 !== null) && (streetAddressLine2 !== undefined)) &&
            <Row>{streetAddressLine2}</Row>}
        <Row>{city}, {state} {postalCode}</Row>
        <Row>{country}</Row>
        </>
        : <div />

    const {emailId, email} = buyer;
    const emailBlock = emailId ?
        <>
            <p/>
            <Row>{email}</Row>
        </> :
        <div />

    const {phoneId, phoneNumber} = buyer
    const phoneBlock = phoneId ?
        <>
            <p />
            <Row>{phoneNumber}</Row>
        </> :
        <div />

    return buyer && <Card title={"Buyer"} width={400}>
            <Row>{buyer.firstname} {buyer.lastname}</Row>
            <Row>{buyer.company}</Row>
            <Row>{buyer.license}</Row>
            {addressBlock}
            {emailBlock}
            {phoneBlock}
        </Card>
}